import React, {useState} from "react";
import Step1RuImg from "./images/step_1_ru.svg";
import Step2RuImg from "./images/step_2_ru.svg";
import Step3RuImg from "./images/step_3_ru.svg";
import Step4RuImg from "./images/step_4_ru.svg";
import Step5RuImg from "./images/step_5_ru.svg";
import Step6RuImg from "./images/step_6_ru.svg";
import Step1EnImg from "./images/step_1_en.svg";
import Step2EnImg from "./images/step_2_en.svg";
import Step3EnImg from "./images/step_3_en.svg";
import Step4EnImg from "./images/step_4_en.svg";
import Step5EnImg from "./images/step_5_en.svg";
import Step6EnImg from "./images/step_6_en.svg";
import { useStyles } from "./style";
import ReactModal from "react-modal";
import {getCurrentLang, Translate} from "../../locales/locales-utils";

type HowToPlayData = {
  isOpen: boolean;
  closeHandle: () => void;
}

const HowToPlayModal = (props: HowToPlayData) => {
  const classes = useStyles();
  const isRuLang = getCurrentLang() === 'ru';

  return (
    <ReactModal
      overlayClassName={'simple-rounded ' + classes.HowToPlayModalOverlay}
      className={classes.HowToPlayModal}
      isOpen={props.isOpen}
      onRequestClose={props.closeHandle}
    >
      <div className={classes.HowToPlayModalHeader}>
        <div className={classes.HowToPlayModalHeaderTitle}>
          {Translate('Index.HowToPlayModal.Title')}
        </div>
        <button onClick={props.closeHandle} className={classes.HowToPlayModalHeaderCloseBtn} />
      </div>
      <div className={classes.HowToPlayModalBody}>
        <div className={classes.HowToPlayItems}>
          <div className={classes.HowToPlayItem}>
            <img src={isRuLang ? Step1RuImg : Step1EnImg} className={classes.HowToPlayItemImg} />
            <div className={classes.HowToPlayItemTitle}>{Translate('Index.HowToPlayModal.Steps.Step1.Title')}</div>
          </div>
          <div className={classes.HowToPlayItem}>
            <img src={isRuLang ? Step2RuImg : Step2EnImg} className={classes.HowToPlayItemImg} />
            <div className={classes.HowToPlayItemTitle}>{Translate('Index.HowToPlayModal.Steps.Step2.Title')}</div>
            <div className={classes.HowToPlayItemDescription}>{Translate('Index.HowToPlayModal.Steps.Step2.Description')}</div>
          </div>
          <div className={classes.HowToPlayItem}>
            <img src={isRuLang ? Step3RuImg : Step3EnImg} className={classes.HowToPlayItemImg} />
            <div className={classes.HowToPlayItemTitle}>{Translate('Index.HowToPlayModal.Steps.Step3.Title')}</div>
            <div className={classes.HowToPlayItemDescription}>{Translate('Index.HowToPlayModal.Steps.Step3.Description')}</div>
          </div>
          <div className={classes.HowToPlayItem}>
            <img src={isRuLang ? Step4RuImg : Step4EnImg} className={classes.HowToPlayItemImg} />
            <div className={classes.HowToPlayItemTitle}>{Translate('Index.HowToPlayModal.Steps.Step4.Title')}</div>
            <div className={classes.HowToPlayItemDescription}>{Translate('Index.HowToPlayModal.Steps.Step4.Description')}</div>
          </div>
          <div className={classes.HowToPlayItem}>
            <img src={isRuLang ? Step5RuImg : Step5EnImg} className={classes.HowToPlayItemImg} />
            <div className={classes.HowToPlayItemTitle}>{Translate('Index.HowToPlayModal.Steps.Step5.Title')}</div>
            <div className={classes.HowToPlayItemDescription}>{Translate('Index.HowToPlayModal.Steps.Step5.Description')}</div>
          </div>
          <div className={classes.HowToPlayItem}>
            <img src={isRuLang ? Step6RuImg : Step6EnImg} className={classes.HowToPlayItemImg} />
            <div className={classes.HowToPlayItemTitle}>{Translate('Index.HowToPlayModal.Steps.Step6.Title')}</div>
            <div className={classes.HowToPlayItemDescription}>{Translate('Index.HowToPlayModal.Steps.Step6.Description')}</div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default HowToPlayModal;